export default __webpack_public_path__ + "static/media/03.11460996.jpg";